export const API_URL = 'https://secure-stream-79742.herokuapp.com';